// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorMessage_message__q56i7"};